export const PRODUCT_NAME = 'AQUA CLASS HUB™';
export const PRODUCT_PRICE = 26.9;
export const CHECKOUT_URL = 'https://aqua-class-hub.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#offer';
export const META_PIXEL_ID = '1822734912085445';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ifn9Eyj67Yx3eaKh57sxbb/Caja_Aqua_Class_Hub__Fitness_Acuatico.png';
export const SUPPORT_EMAIL = 'compradigitalyaa@gmail.com';

// Editable footer links — replace "#" with your real legal page URLs.
export const FOOTER_LINKS = [
  { label: 'Terms & Conditions', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Contact', href: `mailto:${SUPPORT_EMAIL}` },
];

export const formatPrice = (value: number) => `$${value.toFixed(2)}`;
